export default [
    {label: 'Multiniche', value: 'multiniche'},
    {label: 'Asian', value: 'asian'},
    {label: 'Mature', value: 'mature'},
    {label: 'Ladyboys', value: 'ladyboy'},
    {label: 'General', value: 'general'},
    {label: 'Classic', value: 'classic'}
]